//========
//微信分享js调用，目前支持m.huya.com,hd.huya.com,shangjing.huya.com三个域
//=======

/**
 * 微信分享js调用，目前支持m.huya.com,hd.huya.com,shangjing.huya.com三个域
 * @module weixinShare
 */


function getData(url, data, callbackName) {
	return $.ajax({
		url: url,
		dataType: 'jsonp',
		jsonpCallback: callbackName
	});
}


/**
 * 微信分享住类
 * @class WeixinShare
 * @param {Object} shareData 分享填入的参数
 * @param {Boolen} isDebug 是否开启微信debug模式
 */
function WeixinShare(shareData,isDebug) {
	this.data = $.extend({
		title: '', // 分享标题
		desc: '', // 分享描述
		link: '', // 分享链接
		imgUrl: '', // 分享图标
		type: '', // 分享类型,music、video或link，不填默认为link
		dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
		success: function () {
			// 用户确认分享后执行的回调函数
		},
		cancel: function () {
			// 用户取消分享后执行的回调函数
		}
	},shareData)
	this.isDebug = isDebug || false;
	this.init();
}

$.extend(WeixinShare.prototype, {
	init: function() {
		var t = this;
		getData('//m.huya.com/index.php?m=WechatJsApi&do=getSignature', {}, 'getSign').done(function(res) {
			var signInfo = res;
			t.getWeixinJs(signInfo);
		});
	},
	getWeixinJs: function(signInfo) {
		var t = this;
		$.getScript('//hd.huya.com/wapWeixinShareJs/jweixin-1.0.0.js', function() {
			t.weixinInit(signInfo);

		});
	},
	weixinInit: function(signInfo) {
        var t = this;
		wx.config({
            debug: t.isDebug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: signInfo.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: signInfo.timestamp, // 必填，生成签名的时间戳
            nonceStr: signInfo.nonceStr, // 必填，生成签名的随机串
            signature: signInfo.signature,// 必填，签名，见附录1
            jsApiList: ['checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        wx.ready(function() {
            wx.onMenuShareTimeline(t.data);
            wx.onMenuShareAppMessage(t.data);
            wx.onMenuShareQQ(t.data);
            wx.onMenuShareWeibo(t.data);
            wx.onMenuShareQZone(t.data);
        });

        wx.error(function (res) {
        });
	}
});

window.WeixinShare = WeixinShare;
// module.exports = WeixinShare;
export default WeixinShare
